// extracted by mini-css-extract-plugin
export default {"Place":"Place_Place__anAU5","tab":"Place_tab__zRFcP","item":"Place_item__x8wWg","active":"Place_active__z04c2","map":"Place_map__6Z-bG"};